import React from "react";
import bannerTitle from "../../assets/homepage/body/btnttrangchu2.png";
import btnTrangChu from "../../assets/homepage/body/btnttrangchu.png";
import btnQuangTang from "../../assets/homepage/body/btnquangtangttkm.png";
import btnCSKH from "../../assets/homepage/body/btncskh.png";

const BannerTitle = () => {
  return (
    <div className="w-full flex flex-col items-center justify-center min-h-[160px] md:min-h-[220px]">
      <img
        src={bannerTitle}
        alt="Banner Title"
        className="w-full max-w-[1000px] h-auto object-contain px-1 md:px-0"
        draggable={false}
      />

      <div className="mt-3 md:mt-4 flex items-center justify-center gap-3 md:gap-10 md:mb-4">
        <a
          href="https://14444.com"
          target="_blank"
          rel="noopener noreferrer"
          className="block md:hidden transition-transform duration-300 hover:scale-105 active:scale-95"
        >
          <img
            src={btnTrangChu}
            alt="Trang chu"
            className="h-10 md:h-auto md:w-auto object-contain"
            draggable={false}
          />
        </a>
        <a
          href="https://888llwin.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:block transition-transform duration-300 hover:scale-105 active:scale-95"
        >
          <img
            src={btnTrangChu}
            alt="Trang chu"
            className="h-10 md:h-auto md:w-auto object-contain"
            draggable={false}
          />
        </a>
        <a
          href="https://llwinquatang.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="block transition-transform duration-300 hover:scale-105 active:scale-95"
        >
          <img
            src={btnQuangTang}
            alt="Quà tặng"
            className="h-10 md:h-auto md:w-auto object-contain"
            draggable={false}
          />
        </a>
        <a
          href="https://llwin-cskh.pages.dev/"
          target="_blank"
          rel="noopener noreferrer"
          className="block transition-transform duration-300 hover:scale-105 active:scale-95"
        >
          <img
            src={btnCSKH}
            alt="CSKH"
            className="h-10 md:h-auto md:w-auto object-contain"
            draggable={false}
          />
        </a>
      </div>
    </div>
  );
};

export default BannerTitle;
